/**
 *
 * ImportDivisionsContainer
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { DAEMON } from "utils/constants"
import { compose } from "redux"
import { Button, Modal, Progress } from "antd"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { push } from "connected-react-router"
import { get } from "lodash"
import reducer from "./reducer"
import saga from "./saga"

import check from "../../images/check.svg"
import LoadDivisions from "../../components/LoadDivisions"

import {
  makeSelectPercentage,
  makeSelectIsProcessingDivisions,
  makeSelectImportedSummary,
} from "./selectors"

import {
  uploadTemplate,
  saveTemplateWatcher,
  closeImport,
  getDivisionsSummaryWatcher,
} from "./actions"

import { makeSelectHasDivisions } from "../Division/selectors"
import { DeleteOutlined } from "@ant-design/icons"

/* eslint-disable react/prefer-stateless-function */
export class ImportDivisionsContainer extends React.Component {
  state = {
    selectedParent: null,
    openModal: false,
  }

  componentDidMount = () => {
    this.props.getDivisionsSummaryWatcher()
  }

  handleChange = (value) => {
    this.setState({ selectedParent: value })
  }

  toggleModal = (modal, state) => {
    this.setState({ [modal]: state })
  }

  render() {
    const { summary, saveTemplate, percentage, leave } = this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Divisiones</title>
          <meta
            name="description"
            content="Description of ImportDivisionsContainer"
          />
        </Helmet>
        {summary && (
          <LoadDivisions
            leave={leave}
            handleOk={(params) => this.props.saveTemplate(params)}
            handleChange={this.handleChange}
            toggleModal={this.toggleModal}
            summary={summary}
            uploadTemplate={this.props.uploadTemplate}
            hasDivisions={this.props.hasDivisions}
          />
        )}
        <Modal
          visible={this.state.modalDelete}
          onCancel={() => this.toggleModal("modalDelete", false)}
          okText="Aceptar"
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                this.props.clearTable()
                this.toggleModal("modalDelete", false)
              }}>
              Aceptar
            </Button>,
          ]}
          width={520}>
          <div className="modalSuccess">
            <DeleteOutlined
              style={{
                fontSize: "32px",
                color: "#F07F7F",
                alignSelf: "center",
              }}
            />
            <span
              style={{
                justifySelf: "center",
                alignSelf: "center",
                marginTop: "1em",
                fontSize: "14px",
                color: "#555151",
              }}>
              Estás seguro de realizar esta acción?
            </span>
          </div>
        </Modal>
        <Modal
          visible={this.props.isProgressingDivisions || this.state.openModal}
          okText="Aceptar"
          closable={false}
          footer={
            percentage !== 100
              ? null
              : [
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => this.props.closeImport()}>
                    Aceptar
                  </Button>,
                ]
          }
          width={520}>
          {percentage !== 100 ? (
            <div className="modalSuccess">
              <Progress
                style={{ margin: "0 auto" }}
                width={80}
                type="circle"
                percent={percentage}
              />
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                La importación puede tardar unos minutos...
              </span>
            </div>
          ) : (
            <div className="modalSuccess" style={{ textAlign: "center" }}>
              <img src={check} />
              <span
                style={{ marginTop: 14, fontWeight: 600, color: "#555151" }}>
                La importación ha sido completada con éxito.
              </span>
              <span
                style={{
                  justifySelf: "center",
                  alignSelf: "center",
                  marginTop: "1em",
                  fontSize: "14px",
                  color: "#555151",
                }}>
                Ahora podrás visualizar las divisiones de tu organización.
              </span>
            </div>
          )}
        </Modal>
      </React.Fragment>
    )
  }
}

ImportDivisionsContainer.propTypes = { saveTemplate: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  summary: makeSelectImportedSummary(),
  isProgressingDivisions: makeSelectIsProcessingDivisions(),
  percentage: makeSelectPercentage(),
  hasDivisions: makeSelectHasDivisions(),
})

function mapDispatchToProps(dispatch) {
  return {
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
    closeImport: () => dispatch(closeImport()),
    leave: () => dispatch(push("/organization/divisions")),
    saveTemplate: (params) => dispatch(saveTemplateWatcher(params)),
    getDivisionsSummaryWatcher: () => dispatch(getDivisionsSummaryWatcher()),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "importDivisionsContainer", reducer })

const withSaga = injectSaga({
  key: "importDivisionsContainer",
  saga,
  mode: DAEMON,
})

export default compose(
  withReducer,
  withSaga,
  withConnect
)(ImportDivisionsContainer)
